import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  private map: any;
  private marker: any;

  initMap(mapElement: HTMLElement, initialPosition: google.maps.LatLngLiteral): void {
   
    this.map = new google.maps.Map(mapElement, {
      center: initialPosition,
      zoom: 15,
    });

    this.marker = new google.maps.Marker({
      position: initialPosition,
      map: this.map,
      draggable: true,
    });
  }

  setMarkerPosition(position: google.maps.LatLngLiteral): void {
    this.marker.setPosition(position);
  }

  getMarkerPosition(): google.maps.LatLngLiteral {
    return this.marker.getPosition().toJSON();
  }

  // async addMarkerDragEndListener(callback: (position: google.maps.LatLngLiteral) => void) {
  //   const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
  //   const draggableMarker = new AdvancedMarkerElement(this.marker);
 
  //   draggableMarker.addListener('dragend', (event: any) => {
  //     const position = draggableMarker.position as google.maps.LatLng;
  
  //     callback(this.getMarkerPosition());

  //   });

  // }
  async addMarkerDragEndListener(callback: (position: google.maps.LatLngLiteral) => void) {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    const draggableMarker = new AdvancedMarkerElement(this.marker);
   
    draggableMarker.addListener('dragend', (event: any) => {
      const position = draggableMarker.position as google.maps.LatLng;
    
      callback(this.getMarkerPosition());

    });

  }
}

// your-component.component.ts